import ModelAbstract from './ModelAbstract';
import Company from './Company';
import Figure from './Figure';

class CompanyFigure extends ModelAbstract {
    constructor({
        id = null,
        companyId = null,
        company = null,
        figureId = null,
        figure = null,
        createdAt = null,
        updatedAt = null,
    } = {}) {
        super({ id, createdAt, updatedAt });
        this.companyId = companyId;
        this.company = company;
        this.figureId = figureId;
        this.figure = figure;
    }

    /**
     * Factory method to create a CompanyFigure instance from API response
     * @param {Object} data - Raw company figure data from API
     * @returns {CompanyFigure} - Instantiated CompanyFigure object
     */
    static fromAPI(data) {
        if (!data) return null;
        
        const company = data.company ? Company.fromAPI(data.company) : null;
        const figure = data.figure ? Figure.fromAPI(data.figure) : null;
        
        return new CompanyFigure({
            id: data.id,
            companyId: data.company?.id,
            company: company,
            figureId: data.figure?.id,
            figure: figure,
            createdAt: data.createdAt,
            updatedAt: data.updatedAt,
        });
    }

    /**
     * Convert to plain object for JSON serialization
     */
    toJSON() {
        return {
            ...super.toJSON(),
            companyId: this.companyId,
            figureId: this.figureId,
        };
    }
}

export default CompanyFigure;
export { CompanyFigure }; 